import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "condition-header" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["value", "title", "placeholder"]
const _hoisted_4 = { class: "condition-header-meta" }
const _hoisted_5 = { class: "output-count" }
const _hoisted_6 = { class: "condition-ports" }
const _hoisted_7 = { class: "condition-input-label" }
const _hoisted_8 = { class: "connection-indicator" }
const _hoisted_9 = {
  key: 0,
  class: "connected-dot",
  title: "已连接"
}
const _hoisted_10 = { class: "condition-output-fields" }
const _hoisted_11 = ["onUpdate:modelValue", "aria-label", "onBlur"]
const _hoisted_12 = { class: "condition-field" }
const _hoisted_13 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_14 = ["aria-label", "onClick"]
const _hoisted_15 = {
  key: 0,
  class: "condition-port-row no-outputs"
}
const _hoisted_16 = { class: "condition-input-label" }

import { computed, nextTick, onMounted, watch } from "vue";
import { Handle, Position, useVueFlow, type Edge } from "@vue-flow/core";
import type {
  ConditionBranchNode,
  ConditionBranchOutput,
} from "./types/ConditionBranchNode";
import { createConditionBranchOutput } from "./utils/dialogueProject";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConditionBranchNode',
  props: {
    id: {},
    node: {},
    edges: { default: () => [] },
    selected: { type: Boolean, default: false },
    exportIndex: {},
    annotation: { default: "" }
  },
  emits: ["update:annotation"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { updateNodeInternals } = useVueFlow();
const outputSignature = computed(() =>
  props.node.outputs.map((output) => output.id).join("|"),
);

function nextOutputIndex() {
  return props.node.outputs.reduce((maximum, output) => {
    const match = /^分支\s+(\d+)$/.exec(output.label.trim());
    return match ? Math.max(maximum, Number(match[1])) : maximum;
  }, props.node.outputs.length);
}

function addOutput() {
  props.node.outputs.push(createConditionBranchOutput(nextOutputIndex()));
}

function deleteOutput(output: ConditionBranchOutput) {
  const index = props.node.outputs.findIndex((item) => item.id === output.id);
  if (index >= 0) props.node.outputs.splice(index, 1);
}

function ensureOutputLabel(output: ConditionBranchOutput, index: number) {
  if (!output.label.trim()) output.label = `分支 ${index + 1}`;
}

function isConnected(output: ConditionBranchOutput) {
  return props.edges.some(
    (edge) =>
      edge.source === props.id && edge.sourceHandle === output.id,
  );
}

function preventGraphDeletion(event: KeyboardEvent) {
  if (event.key === "Backspace" || event.key === "Delete") event.stopPropagation();
}

async function refreshHandles() {
  await nextTick();
  updateNodeInternals([props.id]);
}

watch(outputSignature, refreshHandles, { flush: "post" });
onMounted(refreshHandles);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["condition-branch-node", { selected: __props.selected }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      (__props.exportIndex !== undefined)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "export-index",
            "aria-label": `TimeLineGroup 索引 ${__props.exportIndex}`,
            title: "导出后的 TimeLineGroup 全局索引，从 0 开始，可用于播放调试"
          }, "#" + _toDisplayString(__props.exportIndex), 9, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        class: "nodrag condition-kind graph-node-annotation",
        value: __props.annotation,
        "aria-label": "节点备注（仅编辑器显示，不参与导出）",
        title: __props.annotation || '点击填写节点备注，仅保存在工程中',
        placeholder: __props.node.name || '条件判断',
        onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:annotation', ($event.target as HTMLInputElement).value))),
        onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
        onKeydown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, null, 40, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.node.outputs.length) + " 个出口", 1),
        _createElementVNode("button", {
          type: "button",
          class: "nodrag add-output-button",
          title: "新增出口",
          onClick: _withModifiers(addOutput, ["stop"])
        }, " ＋ 出口 ")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.outputs, (output, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: output.id,
          class: "condition-port-row"
        }, [
          _createElementVNode("span", _hoisted_7, [
            (index === 0)
              ? (_openBlock(), _createBlock(_unref(Handle), {
                  key: 0,
                  id: "input",
                  class: "condition-input-handle",
                  type: "target",
                  position: _unref(Position).Left,
                  title: "条件分支入口",
                  "aria-label": "条件分支入口"
                }, null, 8, ["position"]))
              : _createCommentVNode("", true),
            (index === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("入口")
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_8, [
            (isConnected(output))
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((output.label) = $event),
              class: "nodrag condition-output-name",
              "aria-label": `出口 ${index + 1} 名称`,
              onBlur: ($event: any) => (ensureOutputLabel(output, index)),
              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            }, null, 40, _hoisted_11), [
              [_vModelText, output.label]
            ]),
            _createElementVNode("label", _hoisted_12, [
              _cache[8] || (_cache[8] = _createElementVNode("span", null, [
                _createTextVNode("表达式 "),
                _createElementVNode("small", null, "字符串")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((output.condition) = $event),
                class: "nodrag nopan nowheel",
                "aria-label": `出口 ${index + 1} 表达式`,
                placeholder: "输入此出口的表达式",
                rows: "2",
                spellcheck: "false",
                onPointerdown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                onKeydown: preventGraphDeletion,
                onKeyup: preventGraphDeletion
              }, null, 40, _hoisted_13), [
                [_vModelText, output.condition]
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "nodrag delete-output-button",
            title: "删除出口并断开对应连线",
            "aria-label": `删除出口 ${index + 1}`,
            onClick: _withModifiers(($event: any) => (deleteOutput(output)), ["stop"])
          }, " × ", 8, _hoisted_14),
          _createVNode(_unref(Handle), {
            id: output.id,
            class: "condition-output-handle",
            type: "source",
            position: _unref(Position).Right,
            title: output.label,
            "aria-label": output.label
          }, null, 8, ["id", "position", "title", "aria-label"])
        ]))
      }), 128)),
      (!__props.node.outputs.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_unref(Handle), {
                id: "input",
                class: "condition-input-handle",
                type: "target",
                position: _unref(Position).Left,
                title: "条件分支入口",
                "aria-label": "条件分支入口"
              }, null, 8, ["position"]),
              _cache[9] || (_cache[9] = _createTextVNode(" 入口 ", -1))
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "暂无出口，请点击“＋ 出口”", -1))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})